import * as Inputs from "../inputs";
import { Func } from "../types";

export const to_lowercase : Func<[string, Record<string, Inputs.InputField>], string> = (input, current_form) => {
    return input.toLowerCase();
}

export const max_length = (length: number): Func<[string, Record<string, Inputs.InputField>], string> => {
    return (input, current_form) => input.length > length ? input.substring(0, length) : input;
}

export const only_integer: Func<[string, Record<string, Inputs.InputField>], string> = (input, current_form) => {
    return input.replace(/[^\d]/g, '');
};

export const combine_filters = <T>(filters: Func<[T, Record<string, Inputs.InputField>], T>[]) : Func<[T, Record<string, Inputs.InputField>], T> => {
    return (input, current_form) => {
        let filtered_value = input;
        for (let i = 0; i < filters.length; i++) {
            filtered_value = filters[i](filtered_value, current_form);
        }
        return filtered_value;
    };
}